const internationalRouter = {
  path: '/international',
  component: () => import('@/layout/orderHeader'),
  children: [
    {
      path: '',
      name: 'International',
      meta: { title: '国际布局' },
      component: () => import(/* webpackChunkName: "international" */ '@/pages/International'),
      redirect: '/international/index',
      children: [
        {
          path: 'index',
          name: 'Index',
          meta: { title: '国际布局' },
          component: () =>
            import(/* webpackChunkName: "international" */ '@/pages/International/pages/country')
        },
        {
          path: 'country/:layoutId',
          name: 'InternationalCountry',
          meta: { title: '国际布局' },
          component: () =>
            import(/* webpackChunkName: "international" */ '@/pages/International/pages/country')
        }
      ]
    },
    {
      path: 'worldmap',
      name: 'worldname',
      meta: { title: '国际布局' },
      component: () => import(/* webpackChunkName: "international" */ '@/pages/International/pages/worldmap')
    },
    {
      path: 'worldmap/provider/:id',
      name: 'Company',
      meta: { title: '公司介绍' },
      component: () =>
        import(/* webpackChunkName: "company" */ '@/pages/International/pages/provider')
    }
  ]
}

export default internationalRouter
